export enum EAnoNe {
    ANO = 'ano',
    NE = 'ne'
}
